// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loCnY7W{display:grid;grid-template-areas:"label" "value";grid-template-columns:2fr 1fr;color:#576875;justify-items:stretch}.loCnY7W:not(:last-child){margin-bottom:.75em}.loCnY7W p{display:flex;align-items:center;color:#576875}.b_0mSk0{padding-top:1em;border-top:1px solid #dee1eb}.ZU05OTU{text-align:left}.JKvebI4{text-align:right}.JKvebI4 p{justify-content:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `loCnY7W`,
	"isTotal": `b_0mSk0`,
	"label": `ZU05OTU`,
	"value": `JKvebI4`
};
export default ___CSS_LOADER_EXPORT___;
